module.exports = __webpack_public_path__ + "img/P33-zh.7b5a2e75.png";